import React, { useState, useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import {
  Card,
  Row,
  Col,
  Button,
  Table,
  Form,
  FormControl
} from 'react-bootstrap';
import Flex from 'components/common/Flex';
import ActionButton from 'components/common/ActionButton';
import DatePicker from 'react-datepicker';
import moment from 'moment';

//global
import { useConfirmModalState } from 'global/confirmModalState';
import useAlarm from 'global/alarmState';
// types
import { MOTHER_SHIP_STATUS_SELECT } from 'types/type';
import { RESPONSE_CODE } from 'types/const';
// modal
import ResultModal from 'components/pages/haccp/mothershipInfo/modal/ResultModal';
import RegistModal from 'components/pages/haccp/mothershipInfo/modal/RegistModal';
// function
import { downloadFile } from 'function/file';
// api
import {
  motherVesselDetail,
  motherVesselFormUpdate,
  requestFileDownload,
  requestFileDelete
} from 'api/haccp/mothershipInfo/mothershipInfoApi';
import { alarmInfo } from 'api/haccp/monitoring/commonApi';
// file upload
import { useDropzone } from 'react-dropzone';
import cloudUpload from 'assets/img/icons/cloud-upload.svg';
import CardDropdown from 'components/common/CardDropdown';
import { getSize } from 'helpers/utils';
import { Dropdown } from 'react-bootstrap';

/**
 * @description 모선정보 상세페이지
 */

const Detail = () => {
  /* router info*/
  const history = useHistory();
  const { state } = useLocation();
  const { seq } = useParams();

  /* recoil */
  const { setConfirmModal } = useConfirmModalState();
  const { setAlarm } = useAlarm();

  /* state */
  const [resultModalShow, setResultModalShow] = useState(false);
  const [registModalShow, setRegistModalShow] = useState(false);
  const [isDisabledCheck, setIsDisabledCheck] = useState(false);
  // 모선정보 상세
  const [motherShipInfo, setMotherShipInfo] = useState({});
  // 현황목록
  const [statusList, setStatusList] = useState([]);
  // 현황상세
  const [statusDetail, setStatusDetail] = useState({});
  // 기존등록된 현황목록 Count
  const [count, setCount] = useState(0);
  const [mappingSeq, setMappingSeq] = useState(null);
  // 현장분석 현황
  const [selfAnalysis, setSelfAnalysis] = useState({});
  // 현자아분석 현황 Origin Data
  const [selfAnalOrigin, setSelfAnalOrigin] = useState({});
  // 자체분석 file upload
  const [files, setFiles] = useState([]);
  // 자체분석 file Oring Data
  const [filesOrigin, setFilesOrigin] = useState([]);

  /* variable */

  // 자체분석 검사결과 Select Box
  const resultSelect = [
    { key: 'out', value: '기준치 초과' },
    { key: 'in', value: '기준치 이내' }
  ];

  // image file dropzone
  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 5,
    onDrop: (acceptedFiles, [{ errors: [error = {}] = [] } = {}]) => {
      const { code } = error || {};
      const imageFiles = [...files, ...acceptedFiles];

      if (code === 'too-many-files' || imageFiles.length > 5) {
        setConfirmModal({
          isOpen: true,
          title: '확인',
          message: '이미지 업로드 최대5개까지 가능합니다.',
          isConfirmBtn: true
        });
        return;
      }

      // 이미지 미리보기
      // imageFiles.map((file, index) => {
      //   file.image = URL.createObjectURL(file);
      //   return file;
      // });

      setFiles(imageFiles);
    }
  });

  /* event */

  /* 첨부파일 다운로드 */
  const onFileDownload = async (seq, fileName) => {
    try {
      const { data } = await requestFileDownload(seq);
      downloadFile(data, fileName);
    } catch (error) {
      setConfirmModal({
        isOpen: true,
        message: '파일 다운로드 에러'
      });
    }
  };

  /* 파일 개별삭제 */
  const onFileRemove = async (seq, path) => {
    // 서버에 등록 된 파일이 아닌 경우
    if (!seq) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: '첨부파일 삭제 하시겠습니까? ',
        isCancelBtn: true,
        isConfirmBtn: true,
        onConfirm: async () => {
          setFiles(files.filter(file => file.path !== path));
        }
      });
      return;
    }

    // 자체분석 첨부파일이 1개인 경우 삭제 불가안내 Modal
    if (files.length === 1) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: '삭제 시 첨부파일이 없습니다. \n 추가 등록 후 삭제 해 주세요.',
        isConfirmBtn: true
      });
      return;
    }

    setConfirmModal({
      isOpen: true,
      title: '확인',
      message:
        '등록 된 첨부파일 삭제 하시겠습니까? \n 삭제 시 파일은 복구되지 않습니다.',
      isCancelBtn: true,
      isConfirmBtn: true,
      onConfirm: async () => {
        const { code, message } = await requestFileDelete(seq);

        if (code !== RESPONSE_CODE.Success) {
          setConfirmModal({
            isOpen: true,
            title: '확인',
            message: message,
            isConfirmBtn: true
          });
          return;
        }

        setConfirmModal({
          isOpen: true,
          title: '확인',
          message: '삭제되었습니다.',
          isConfirmBtn: true
        });

        onDetail();
      }
    });
  };

  /**
   * 모선정보 상태선택
   * 1: 사용중
   * 2: 사용완료
   */
  const onStatus = e => {
    const { value } = e.target || {};
    const status = Number(value);
    const { lastStockDt = null } = motherShipInfo || {};

    setMotherShipInfo({
      ...motherShipInfo,
      mthvessStatus: status
    });

    // 상태값 사용완료(2) 인 경우 최종입고일 필수안내 Modal
    if (status === 2 && lastStockDt === null) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: '최종입고일을 선택해주세요.',
        isConfirmBtn: true
      });
    }
  };

  /* 최종입고일 날짜선택 */
  const onDateChange = date => {
    setMotherShipInfo({
      ...motherShipInfo,
      lastStockDt: date
    });
  };

  /* 자체분석일시 날짜선택 */
  const onAnalysysDateChange = date => {
    setSelfAnalysis({
      ...selfAnalysis,
      selfInspDt: date
    });
  };

  /* 현황상세 선택 */
  const onResultDetail = index => {
    setStatusDetail(statusList[index]);
    setResultModalShow(true);
  };

  /* 목록페이지 이동 */
  const onList = () => {
    history.push({
      pathname: '/haccp/mothershipInfo',
      state: state
    });
  };

  /* 검사결과 수정 */
  const onResultUpdate = index => {
    setMappingSeq(statusList[index].seq);
    setRegistModalShow(true);
  };

  /* 검사결과 삭제 */
  const onResultDelete = seq => {
    setConfirmModal({
      isOpen: true,
      title: '확인',
      message: '삭제 하시겠습니까?',
      isCancelBtn: true,
      isConfirmBtn: true,
      onConfirm: () => {
        setStatusList(statusList?.filter(e => e.seq !== seq));
      }
    });
  };

  /* 검사결과 신규등록 */
  const modalRegistConfirm = array => {
    const tempArray = array?.map(e => ({
      ...e,
      isDisabled: false
    }));

    const maxCount = count + 1;

    // 모선정보 현황  신규등록 -> 기존등록된 현황에 추가적으로 1개만 등록가능
    if (statusList?.length < maxCount) {
      // 검사의뢰일 내림차순 정렬
      const newList = [...tempArray, ...statusList]?.sort(
        (a, b) => new Date(b.inspReqDt) - new Date(a.inspReqDt)
      );
      setStatusList(newList);
    }

    // 신규등록 후 수정가능
    if (statusList.length === maxCount) {
      const array = statusList.filter(item => item.orders);

      // 검사의뢰일 내림차순 정렬
      const newList = [...tempArray, ...array]?.sort(
        (a, b) => new Date(b.inspReqDt) - new Date(a.inspReqDt)
      );

      setStatusList(newList);
    }

    setRegistModalShow(false);
  };

  /* 모선정보 등록 */
  const onRegist = () => {
    const { mthvessStatus, lastStockDt } = motherShipInfo || {};

    if (mthvessStatus === '') {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: '상태를 선택해주세요.',
        isConfirmBtn: true
      });
      return;
    }

    if (mthvessStatus === 2 && lastStockDt === null) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: '최종입고일을 선택해주세요.',
        isConfirmBtn: true
      });

      return;
    }

    const {
      selfInspDt = null,
      selfInspResult = null,
      selfInspIrdntNm = null
    } = selfAnalysis || {};

    /**
     * 자체분석 이미지 첨부한 경우
     * 자체분석일시, 검사항목, 자체분석 검사결과 필수선택
     */
    if (
      files.length > 0 &&
      (selfInspDt === null ||
        selfInspResult === null ||
        selfInspIrdntNm === null)
    ) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: '자체분석 일시, 검사항목, 자체분석 검사결과를 선택해주세요.',
        isConfirmBtn: true
      });
      return;
    }

    setConfirmModal({
      isOpen: true,
      title: '확인',
      message: '설정한 정보를 등록하시겠습니까?',
      isCancelBtn: true,
      isConfirmBtn: true,
      onConfirm: () => {
        onSubmit();
      }
    });
  };

  const onSubmit = async () => {
    const { lastStockDt, mthvessStatus } = motherShipInfo || [];
    let lastDate = lastStockDt || null;

    if (lastDate !== null) {
      lastDate = moment(lastStockDt).format('YYYY-MM-DD');
    }

    const isNewCheck = statusList?.some(e => e.isDisabled === false);
    const newInspResultOrders =
      statusList?.filter(e => e.isDisabled === false)[0]?.seq || undefined;

    const { selfInspDt, selfInspResult, selfInspIrdntNm, selfInspDescription } =
      selfAnalysis || {};

    let selfInspUpdYn = 'N';

    // 현장분석 현황 신규파일 추가 한 경우
    const newFiles = files?.filter(e => !e.seq) || [];

    if (newFiles.length > 0) {
      selfInspUpdYn = 'Y';
    }

    // 현장분석 현황 파일 삭제 및 추가 한 경우
    if (files.length !== filesOrigin.length) {
      selfInspUpdYn = 'Y';
    }

    // 현장분석 현황 데이터 비교
    const AnalData = Object.keys(selfAnalysis)
      .sort()
      .reduce((obj, key) => ((obj[key] = selfAnalysis[key]), obj), {});
    const AnalOriginData = Object.keys(selfAnalOrigin)
      .sort()
      .reduce((obj, key) => ((obj[key] = selfAnalOrigin[key]), obj), {});

    if (JSON.stringify(AnalData) !== JSON.stringify(AnalOriginData)) {
      selfInspUpdYn = 'Y';
    }

    const requestBody = {
      lastStockDt: lastDate,
      mthvessStatus: mthvessStatus,
      newInspResultSeq: isNewCheck === true ? newInspResultOrders : null,
      newInspResultOrders: isNewCheck === true ? statusList.length : null,
      selfInspDt: selfInspDt
        ? moment(selfInspDt).format('YYYY-MM-DD[T]HH:mm:ss')
        : null,
      selfInspResult: selfInspResult,
      selfInspIrdntNm: selfInspIrdntNm,
      selfInspDescription: selfInspDescription,
      newSelfInspFiles: files?.filter(e => !e.seq),
      selfInspUpdYn: selfInspUpdYn
    };

    Object.keys(requestBody)?.forEach(
      key => !requestBody[key] && delete requestBody[key]
    );

    const response = await motherVesselFormUpdate(seq, requestBody);

    const { code, message } = response || {};

    if (code !== RESPONSE_CODE.Success) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: message,
        isConfirmBtn: true
      });
      return;
    }

    setConfirmModal({
      isOpen: true,
      title: '확인',
      message: '설정한 정보가 등록되었습니다.',
      isConfirmBtn: true
    });

    /* 추가 검사결과 등록을 위해 모선목록페이지 이동 x
     * 선진 요구사항
     */
    onDetail();

    // 알람정보 Update
    alarm();
  };

  /*상세 API호출*/
  const onDetail = async () => {
    const response = await motherVesselDetail(seq);

    const { code, data, message } = response || {};

    if (code !== RESPONSE_CODE.Success) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: message,
        isConfirmBtn: true
      });
      return;
    }

    const {
      pltCd, // 공장코드
      pltNm, // 공장명
      matnr, // 원료코드
      maktx, // 원료명
      licha, // 모선명
      landx, // 원산지명
      budat, // 최초입고일
      lastStockDt, // 최종입고일
      preAnalsDt, // 사전분석일
      preAnalsComptDt, // 사전분석완료일
      perdAnalsDt, // 정기분석일
      mthvessStatus, // 상태
      inspResultMthvessMapList = [],
      selfInspDt, // 자체분석일시
      selfInspIrdntNm, // 자체분석 검사항목
      selfInspResult, // 자체분석 검사결과
      selfInspRegDt, // 자체분석 등록일시
      selfInspUpdDt, // 자체분석 수정일시
      selfInspDescription, // 자체분석비고
      selfInspFiles = [] // 자체분석 파일
    } = data || [];

    // 모선정보 상태값 입고완료(2)인 경우 수정불가
    if (mthvessStatus === 2) {
      setIsDisabledCheck(true);
    }

    // 모선정보 상세
    setMotherShipInfo({
      ...motherShipInfo,
      pltCd,
      pltNm,
      matnr,
      maktx,
      licha,
      landx,
      budat,
      lastStockDt: lastStockDt ? new Date(lastStockDt) : null,
      preAnalsDt,
      preAnalsComptDt,
      perdAnalsDt,
      mthvessStatus: mthvessStatus ? mthvessStatus : ''
    });

    // 자체분석 현황
    setSelfAnalysis({
      ...selfAnalysis,
      selfInspDt: selfInspDt ? new Date(selfInspDt) : null,
      selfInspIrdntNm,
      selfInspResult,
      selfInspDescription,
      selfInspRegDt,
      selfInspUpdDt
    });

    // 자체분석 현황 Origin Data
    setSelfAnalOrigin({
      ...selfAnalysis,
      selfInspDt: selfInspDt ? new Date(selfInspDt) : null,
      selfInspIrdntNm,
      selfInspResult,
      selfInspDescription,
      selfInspRegDt,
      selfInspUpdDt
    });

    // 자체분석 파일
    setFiles(selfInspFiles);

    // 자체분석 파일 Origin data
    setFilesOrigin(selfInspFiles);

    // Mapping완료된 검사결과는 수정불가
    setStatusList(
      inspResultMthvessMapList
        ?.map(e => ({
          ...e,
          isDisabled: true
        }))
        ?.sort((a, b) => new Date(b.inspReqDt) - new Date(a.inspReqDt))
    );
    // Mapping완료된 검사결과 Count
    setCount(inspResultMthvessMapList?.length ?? 0);
  };

  /** 모선정보 등록 및 수정
   *  모선알람 Update
   */
  const alarm = async () => {
    const response = await alarmInfo();

    const { code, data = [] } = response || {};

    if (code !== RESPONSE_CODE.Success) return;

    setAlarm(data);
  };

  /* watch */
  useEffect(() => {
    // 상세API 호출
    onDetail();
  }, [seq]);

  return (
    <>
      <Card>
        <Card.Header>
          <Row className="align-items-center g-2">
            <Col>
              <h5 className="mb-0">
                모선정보 상세 ({motherShipInfo.pltNm || '-'})
              </h5>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body className="pt-0">
          <Table bordered className="fs--1 text-center">
            <tbody className="align-middle">
              <tr>
                <th
                  className="bg-200 text-700 border-300"
                  style={{ width: '15%' }}
                >
                  원료코드
                </th>
                <td style={{ width: '35%' }}>{motherShipInfo.matnr || '-'}</td>
                <th
                  className="bg-200 text-700 border-300"
                  style={{ width: '15%' }}
                >
                  원료명
                </th>
                <td style={{ width: '35%' }}>{motherShipInfo.maktx || '-'}</td>
              </tr>
              <tr>
                <th
                  className="bg-200 text-700 border-300"
                  style={{ width: '15%' }}
                >
                  모선명
                </th>
                <td style={{ width: '35%' }}>{motherShipInfo.licha || '-'}</td>
                <th
                  className="bg-200 text-700 border-300"
                  style={{ width: '15%' }}
                >
                  원산지명
                </th>
                <td style={{ width: '35%' }}>{motherShipInfo.landx || '-'}</td>
              </tr>
              <tr>
                <th
                  className="bg-200 text-700 border-300"
                  style={{ width: '15%' }}
                >
                  최초입고일
                </th>
                <td style={{ width: '35%' }}>{motherShipInfo.budat || '-'}</td>
                <th
                  className="bg-200 text-700 border-300"
                  style={{ width: '15%' }}
                >
                  최종입고일
                </th>
                <td style={{ width: '35%' }}>
                  <DatePicker
                    locale="ko"
                    onChange={onDateChange}
                    selected={motherShipInfo.lastStockDt}
                    startDate={motherShipInfo.lastStockDt}
                    formatWeekDay={day => day.slice(0, 1)}
                    dateFormat="yyyy-MM-dd"
                    className="form-control form-control-sm"
                    placeholderText="상태가 사용완료인 경우 최종입고일 선택가능합니다."
                    disabled={
                      motherShipInfo.mthvessStatus === 1 ||
                      isDisabledCheck === true
                    }
                  />
                </td>
              </tr>
              <tr>
                <th
                  className="bg-200 text-700 border-300"
                  style={{ width: '15%' }}
                >
                  사전분석일
                </th>
                <td style={{ width: '35%' }}>
                  {motherShipInfo.preAnalsDt || '-'}
                </td>
                <th
                  className="bg-200 text-700 border-300"
                  style={{ width: '15%' }}
                >
                  사전분석완료일
                </th>
                <td style={{ width: '35%' }}>
                  {motherShipInfo.preAnalsComptDt || '-'}
                </td>
              </tr>
              <tr>
                <th
                  className="bg-200 text-700 border-300"
                  style={{ width: '15%' }}
                >
                  정기분석일
                </th>
                <td style={{ width: '35%' }}>
                  {motherShipInfo.perdAnalsDt || '-'}
                </td>
                <th
                  className="bg-200 text-700 border-300"
                  style={{ width: '15%' }}
                >
                  상태
                </th>
                <td style={{ width: '35%' }}>
                  <Form.Select
                    size="sm"
                    className="w-100"
                    name="factory"
                    value={motherShipInfo.mthvessStatus}
                    onChange={e => onStatus(e)}
                    disabled={isDisabledCheck}
                  >
                    <option hidden value={''}>
                      상태를 선택해주세요.
                    </option>
                    {MOTHER_SHIP_STATUS_SELECT?.map(option => (
                      <option key={option.key} value={option.key}>
                        {option.value}
                      </option>
                    ))}
                  </Form.Select>
                </td>
              </tr>
            </tbody>
          </Table>
          <Flex className="mb-1">
            <h6 className="fs-0">* 현장분석 현황</h6>
          </Flex>
          <Table bordered className="fs--1 text-center">
            <tbody className="align-middle">
              <tr>
                <th
                  className="bg-200 text-700 border-300"
                  style={{ width: '15%' }}
                >
                  * 자체분석 첨부
                </th>
                <td colSpan={3}>
                  {isDisabledCheck === false && (
                    <div
                      {...getRootProps({
                        className: 'dropzone-area bg-200 w-50 py-1 m-auto'
                      })}
                    >
                      <input {...getInputProps()} />
                      <Flex
                        justifyContent="center"
                        alignItems="center"
                        className="h-100"
                      >
                        <img
                          src={cloudUpload}
                          alt="Drop your files here"
                          className="me-2"
                          width={25}
                        />
                        <p className="fs-0 mb-0 text-700">
                          이미지 업로드( 최대5개 )
                        </p>
                      </Flex>
                    </div>
                  )}
                  <Flex alignItems="center">
                    {files.map((file, index) => (
                      <Flex
                        className="py-3 btn-reveal-trigger ms-3"
                        key={index}
                      >
                        {/* <img src={file.image} width={40} height={40} /> */}
                        <Flex
                          justifyContent="between"
                          alignItems="center"
                          className="ms-3"
                        >
                          <div>
                            <h6>{file.originFileNm || file.path}</h6>
                            <Flex className="position-relative">
                              <p className="mb-0 fs--1 text-400 line-height-1">
                                <strong> {getSize(file.size)} </strong>
                              </p>
                            </Flex>
                          </div>
                        </Flex>
                        <CardDropdown>
                          <div className="py-2">
                            {file.seq && (
                              <Dropdown.Item
                                onClick={() =>
                                  onFileDownload(file.seq, file.originFileNm)
                                }
                              >
                                다운로드
                              </Dropdown.Item>
                            )}
                            {isDisabledCheck === false && (
                              <Dropdown.Item
                                className="text-danger"
                                onClick={() =>
                                  onFileRemove(file.seq, file.path)
                                }
                              >
                                삭제
                              </Dropdown.Item>
                            )}
                          </div>
                        </CardDropdown>
                      </Flex>
                    ))}
                  </Flex>
                </td>
              </tr>
              <tr>
                <th
                  className="bg-200 text-700 border-300"
                  style={{ width: '15%' }}
                >
                  * 자체분석 일시
                </th>
                <td style={{ width: '35%' }}>
                  <DatePicker
                    locale="ko"
                    onChange={onAnalysysDateChange}
                    selected={selfAnalysis.selfInspDt}
                    startDate={selfAnalysis.selfInspDt}
                    formatWeekDay={day => day.slice(0, 1)}
                    dateFormat="yyyy-MM-dd h:mm"
                    timeIntervals={5}
                    showTimeSelect
                    className="form-control form-control-sm"
                    placeholderText="자체분석 일시를 선택해주세요."
                    disabled={isDisabledCheck}
                  />
                </td>
                <th
                  className="bg-200 text-700 border-300"
                  style={{ width: '15%' }}
                >
                  * 검사항목
                </th>
                <td style={{ width: '35%' }}>
                  <FormControl
                    type="text"
                    placeholder="검사항목 입력해주세요."
                    size="sm"
                    maxLength="20"
                    value={selfAnalysis.selfInspIrdntNm || ''}
                    onChange={e =>
                      setSelfAnalysis({
                        ...selfAnalysis,
                        selfInspIrdntNm: e.target.value
                      })
                    }
                    disabled={isDisabledCheck}
                  />
                </td>
              </tr>
              <tr>
                <th
                  className="bg-200 text-700 border-300"
                  style={{ width: '15%' }}
                >
                  * 자체분석 검사결과
                </th>
                <td style={{ width: '35%' }}>
                  <Form.Select
                    size="sm"
                    className="w-100"
                    name="inspectionResult"
                    value={selfAnalysis.selfInspResult}
                    onChange={e =>
                      setSelfAnalysis({
                        ...selfAnalysis,
                        selfInspResult: e.target.value
                      })
                    }
                    disabled={isDisabledCheck}
                  >
                    <option hidden value={''}>
                      자체분석 검사결과를 선택해주세요.
                    </option>
                    {resultSelect?.map(option => (
                      <option key={option.key} value={option.key}>
                        {option.value}
                      </option>
                    ))}
                  </Form.Select>
                </td>
                <th
                  className="bg-200 text-700 border-300"
                  style={{ width: '15%' }}
                >
                  자체분석 등록일시
                </th>
                <td style={{ width: '35%' }}>
                  {selfAnalysis.selfInspUpdDt || selfAnalysis.selfInspRegDt}
                </td>
              </tr>
              <tr>
                <th
                  className="bg-200 text-700 border-300"
                  style={{ width: '15%' }}
                >
                  비고
                </th>
                <td colSpan={3}>
                  <FormControl
                    type="text"
                    placeholder="20자 이내로 입력해주세요."
                    size="sm"
                    maxLength="20"
                    value={selfAnalysis.selfInspDescription || ''}
                    onChange={e =>
                      setSelfAnalysis({
                        ...selfAnalysis,
                        selfInspDescription: e.target.value
                      })
                    }
                    disabled={isDisabledCheck}
                  />
                </td>
              </tr>
            </tbody>
          </Table>

          <Flex className="mb-3">
            <h6 className="fs-0">* 현황</h6>
            {statusList?.length <= count && isDisabledCheck === false && (
              <Button
                size="sm"
                className="ms-auto"
                onClick={() => setRegistModalShow(true)}
              >
                검사결과 등록
              </Button>
            )}
          </Flex>
          <Table bordered hover className="fs--1 text-center">
            <thead className="bg-200 text-700 align-middle border-300">
              <tr>
                <th className="text-nowrap">번호</th>
                <th className="text-nowrap">검사결과 Type</th>
                <th className="text-nowrap">원료코드</th>
                <th className="text-nowrap">원료명</th>
                <th className="text-nowrap">모선명</th>
                <th className="text-nowrap">원산지명</th>
                <th className="text-nowrap">검사의뢰일</th>
                <th className="text-nowrap">검사완료일</th>
                <th className="text-nowrap">관리</th>
              </tr>
            </thead>
            <tbody>
              {statusList?.map(
                (
                  {
                    seq,
                    inspResultTypeNm,
                    sampleCd,
                    sampleNm,
                    cshipNm,
                    coriNm,
                    inspReqDt,
                    inspCmtDt,
                    isDisabled
                  },
                  index
                ) => (
                  <tr key={index}>
                    <td
                      className="cursor-pointer"
                      onClick={() => onResultDetail(index)}
                    >
                      {index + 1 || '-'}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => onResultDetail(index)}
                    >
                      {inspResultTypeNm || '-'}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => onResultDetail(index)}
                    >
                      {sampleCd || '-'}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => onResultDetail(index)}
                    >
                      {sampleNm || '-'}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => onResultDetail(index)}
                    >
                      {cshipNm || '-'}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => onResultDetail(index)}
                    >
                      {coriNm || '-'}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => onResultDetail(index)}
                    >
                      {inspReqDt || '-'}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => onResultDetail(index)}
                    >
                      {inspCmtDt || '-'}
                    </td>
                    <td>
                      {isDisabled === false && (
                        <>
                          <ActionButton
                            icon="edit"
                            title="수정"
                            variant="action"
                            className="p-0 lh-1"
                            onClick={() => onResultUpdate(index)}
                          />
                          <ActionButton
                            icon="trash-alt"
                            title="삭제"
                            variant="action"
                            className="p-0 lh-1 ms-2"
                            onClick={() => onResultDelete(seq)}
                          />
                        </>
                      )}
                      {isDisabled === true && <>-</>}
                    </td>
                  </tr>
                )
              )}
              {statusList?.length < 1 && (
                <tr>
                  <td colSpan={9} className="w-auto">
                    검사결과 정보가 존재하지 않습니다.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Card.Body>
        <Card.Footer className="d-flex align-items-center">
          <Button
            size="sm"
            variant="secondary"
            className="ms-auto"
            onClick={() => onList()}
          >
            목록
          </Button>
          {isDisabledCheck === false && (
            <Button
              size="sm"
              className="ms-2"
              type="button"
              onClick={() => onRegist()}
            >
              등록
            </Button>
          )}
        </Card.Footer>
      </Card>
      {/*검사결과등록 Modal*/}
      {registModalShow === true && (
        <RegistModal
          registModalShow={registModalShow}
          setRegistModalShow={setRegistModalShow}
          modalRegistConfirm={modalRegistConfirm}
          motherShipInfo={motherShipInfo}
          mappingSeq={mappingSeq}
        ></RegistModal>
      )}

      {/*검사결과상세 Modal*/}
      <ResultModal
        resultModalShow={resultModalShow}
        setResultModalShow={setResultModalShow}
        statusDetail={statusDetail}
      ></ResultModal>
    </>
  );
};

export default Detail;
